import { attr, html, TNode, Value } from '@tempots/dom'

export type SectionOptions = {
  background: Value<'white' | 'light' | 'dark'>
}

export function Section({ background }: SectionOptions, ...children: TNode[]) {
  return html.section(
    attr.class('p-4 sm:p-6 md:p-8 lg:p-12 flex items-center justify-center'),
    attr.class(
      Value.map(background, (bg): string =>
        bg === 'white'
          ? 'bg-white'
          : bg === 'light'
            ? 'bg-[#FFFAF8]'
            : 'bg-gray-800'
      )
    ),
    html.div(attr.class('max-w-7xl w-full'), ...children)
  )
}
